var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('SystemMessage'),_c('main',{staticClass:"root-element"},[_c('Breadcrumbs'),_c('PageTitle'),_c('Help'),_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }